export const Bio = {
  name: "Swarup Chanda",
  roles: [
    "Full Stack Developer",
    "Robotics Enthusiast",
    "Programmer",
    "ML Enthusiast",
    "Video Editor",
    "Arduino Programmer",
    "App Developer",
  ],
  description:
    "Pursuing a B.Tech in Computer Science and Engineering at NIT Silchar, I'm on an odyssey of continuous learning. I'm sculpting a multidimensional skill set, weaving my experiences into innovation and growth.",
  github: "https://github.com/swarupecenits",
  resume:
    "https://drive.google.com/file/d/1WhryeEsULP-3q6lZXpleW26c0jZbB4tz/view",
  linkedin: "https://www.linkedin.com/in/swarup-chanda-23053724a/",
  reddit: "https://www.reddit.com/user/Round-Moose970/",
  insta: "https://www.instagram.com/this_is_swarup_/",
  facebook: "https://www.facebook.com/swarup.chanda.984?mibextid=ZbWKwL",
  youtube: "https://www.youtube.com/channel/UCDuvuuT8Rtgw1JPz84APl5A",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "https://reactnative.dev/img/header_logo.svg",
      },
      {
        name: "ReactNative",
        image:
          "https://reactnative.dev/img/header_logo.svg",
      },
      {
        name: "Next Js",
        image:
          "https://cdn.worldvectorlogo.com/logos/next-js.svg",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/v1773635375/css3-seeklogo_v1bupq.png",
      },
      {
        name: "JavaScript",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/v1773635374/javascript_logo_ub1eur.png",
      },
      {
        name: "ThreeJS",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRBQIUAO3NbXGjQjASqXqyv7hC9hTerlGRrnqkkBR0LPA&s",
      },
      {
        name: "Sass",
        image:
          "https://sass-lang.com/assets/img/styleguide/seal-color.png",
      },
      {
        name: "Expo",
        image:
          "https://cdn.worldvectorlogo.com/logos/expo-1.svg",
      },
      {
        name: "FramerMotion",
        image:
          "https://cdn.worldvectorlogo.com/logos/framer-motion.svg",
      },
    ],
  },

  {
    title: "Language",
    skills: [
      {
        name: "C++",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/bwmwosxmgkk1vkgvmmkb",
      },
      {
        name: "C",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/fresjkfqexmvz5ltqhql",
      },
      {
        name: "C#",
        image:
          "https://imgs.search.brave.com/fwOD7cVO8n0triTpajdEFkNo6wgW4HpsZ9hJDaNlslA/rs:fit:860:0:0:0/g:ce/aHR0cHM6Ly9zdHls/ZXMucmVkZGl0bWVk/aWEuY29tL3Q1XzJx/aGRmL3N0eWxlcy9j/b21tdW5pdHlJY29u/X3NrOGsyaGlzdnl2/NTEucG5n",
      },
      {
        name: "Python",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/pbxqeucqd0yapx9wovqu",
      },
      {
        name: "JavaScript",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/v1773635374/javascript_logo_ub1eur.png",
      },
      {
        name: "JAVA",
        image:
          "https://cdn-icons-png.flaticon.com/128/226/226777.png",
      },
      {
        name: "Matlab",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/glwnyr790oabfx6jv7b7",
      },
      {
        name: "Solidity",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/axozw7w2wazs591z8a41",
      },
      {
        name: "SimuLink",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/huqtgx8rvjbqsyffo1ti",
      },
      {
        name: "R",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/xrf3rahxgjrdpi4fltkp",
      },
      {
        name: "Playwright",
        image:
          "https://playwright.dev/img/playwright-logo.svg",
      },

    ],
  },
  {
    title: "Backend and Services",
    skills: [
      {
        name: "Node Js",
        image: "https://raw.githubusercontent.com/devicons/devicon/master/icons/nodejs/nodejs-original-wordmark.svg",
      },
      {
        name: "Express Js",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/v1765817561/Express_ibbwwp.png",
      },
      {
        name: "Python",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/pbxqeucqd0yapx9wovqu",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "OpenAI",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcRQVRSNCZKUcvSYkmDLtSNNaRwRDh8rz5HxHA&s",
      },
      {
        name: "Docker",
        image:
          "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/97_Docker_logo_logos-1024.png",
      },
      {
        name: "Redux",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/redux/redux-original.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://cdn.icon-icons.com/icons2/2415/PNG/512/mongodb_original_wordmark_logo_icon_146425.png",
      },
      {
        name: "AppWrite",
        image:
          "https://appwrite.io/assets/logomark/logo.png",
      },
      {
        name: "Firebase",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/c/cf/Firebase_icon.svg/180px-Firebase_icon.svg.png",
      },
      {
        name: "Ethereum",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/pacokq4weanpznjmaqhr",
      },
      {
        name: "Azure DevOps Pipeline",
        image:
          "https://cdn-dynmedia-1.microsoft.com/is/content/microsoftcorp/Microsoft_Azure?resMode=sharp2&op_usm=1.5,0.65,15,0&qlt=100&fmt=png-alpha",
      },

    ],
  },
  {
    title: "Machine Learning",
    skills: [
      {
        name: "Jupyter",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/ssx6s7l1jb0mdkd64unj",
      },
      {
        name: "Python",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/pbxqeucqd0yapx9wovqu",
      },
      {
        name: "OpenCV",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/lxfpf2yvjefysajiskp1",
      },
      {
        name: "TensorFlow",
        image:
          "https://images.seeklogo.com/logo-png/39/1/tensorflow-logo-png_seeklogo-394548.png",
      },
      {
        name: "Pytorch",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQQs9gwB4SmvtMIo6OalC-8yCctF5IOT_r-Yw&s",
      },
      {
        name: "Scikit Learn",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/t4ltww9mlaapskta8zrv",
      },
      {
        name: "Keras",
        image:
          "https://miro.medium.com/v2/resize:fit:600/1*DKu_54iqz6C-p6ndo7rO3g.png",
      },
      {
        name: "Anaconda",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/jrnkmzub85xzm3fki129",
      },

    ],
  },
  {
    title: "Others",
    skills: [
      {
        name: "Arduino IDE",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/dm5tyzxel680kvsnrvct",
      },
      {
        name: "Azure AI Foundry",
        image:
          "https://cdn-dynmedia-1.microsoft.com/is/content/microsoftcorp/Microsoft_Azure?resMode=sharp2&op_usm=1.5,0.65,15,0&qlt=100&fmt=png-alpha",
      },
      {
        name: "ROS",
        image:
          "https://miro.medium.com/v2/resize:fit:580/0*N8Ew1wXNRVOSNO8m",
      },
      {
        name: "Git",
        image:
          "https://iconape.com/wp-content/png_logo_vector/git-icon.png",
      },
      {
        name: "Netlify",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/v1765817561/netlify_sue285.svg",
      },
      {
        name: "GitHub",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/rjlqses57qfadwoeklib",
      },
      {
        name: "CapCut",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTckL41sNrF2exb39U4-e_qcMPWsNFhrEzRUsD9cPY&s",
      },
      {
        name: "VS Code",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/jdlqm8qkvypvzg4focgk",
      },
      {
        name: "Mission Planner",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/v5zj3nsvkafdkgzgb1l4",
      },
      {
        name: "Canva",
        image:
          "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTX_-vZPAg61UMIpxhfNMOLxDZNTcRxTOy4lkGUuASoDA&s",
      },
      {
        name: "Filmora",
        image:
          "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/n2qbksenf57daaymtieh",
      },
      {
        name: "Altium-PCB",
        image:
          "https://5.imimg.com/data5/SELLER/Default/2023/12/369981375/LG/VW/AF/195873594/ad-logo-vertical-light-bg.png",
      },
      {
        name: "Figma",
        image:
          "https://s3-alpha.figma.com/hub/file/1481185752/fa4cd070-6a79-4e1b-b079-8b9b76408595-cover.png",
      },
      {
        name: "AutoCAD",
        image:
          "https://images.sftcdn.net/images/t_app-icon-m/p/8a1acc12-96d0-11e6-b61e-00163ed833e7/481981230/autocad-icon.png",
      },
      {
        name: "8085/8086 Programming",
        image:
          "data:image/jpeg;base64,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",
      },
    ],
  },
];

export const experiences = [
  {
    id: 10,
    img: "https://res.cloudinary.com/dagggqd6g/image/upload/v1765819007/microsoft-logo-microsoft-icon-transparent-free-png_shxjdw.webp",
    role: "Software Engineer",
    company: "Microsoft India",
    date: "Jul 2026 - Present",
    desc: "Working as a Software Engineer at Microsoft India, developing AI-driven systems for autonomous browser interaction and end-to-end testing. Building scalable automation frameworks using Azure OpenAI and modern DevOps pipelines, contributing to improved software reliability and efficiency.",
   
  },
  {
    id: 10,
    img: "https://res.cloudinary.com/dagggqd6g/image/upload/v1765819007/microsoft-logo-microsoft-icon-transparent-free-png_shxjdw.webp",
    role: "SWE Intern",
    company: "Microsoft India",
    date: "May 2025 - July 2025",
    desc: "Developed and integrated AI based software for an autonomous browser interaction, enhancing automation using AI, creating End to end testing model that can test any website autonomously and create assertions autonomously, and receiving commendations for innovation.",
    skills: [
      "AI Agent",
      "Browser Automation",
      "Web Services",
      "Azure OpenAI",
      "DevOps Pipeline",
      "Azure AI Foundry",
      "E2E Test Automation",
      "Playwright Test Tool",
    ],
  },
  {
    id: 10,
    img: "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/vcrterwiwnvzdqptpcni",
    role: "Project Intern",
    company: "Nephrocare India",
    date: "May 2024 - May 2026",
    desc: "Developed an innovative cloud-based Blood flow monitoring system for Dialysis machines during my internship, integrating real-time remote control, web-based functionality, and affordability to revolutionize healthcare accessibility and efficiency.",
    skills: [
      "Machine Learning",
      "Internet of Things (IoT)",
      "Web Services",
      "Web Development",
      "Cloud Applications",
      "Arduino",
      "ESP32 Microcontrollers",
      "Electronics Hardware Design",
    ],
  },
  {
    id: 10,
    img: "https://res.cloudinary.com/dagggqd6g/image/upload/v1765819269/images_yt9ce5.png",
    role: "Amazon Summer School 2024",
    company: "Amazon",
    date: "July 2024 - Aug 2024",
    desc: "Participated in Amazon Summer School 2024, gaining insights into cutting-edge technologies and business practices, enhancing skills in a dynamic learning environment at Amazon.",
    skills: [
      "Machine Learning",
      "Supervised Learning",
      "Deep Neural Networks",
      "Casual Inferences",
      "Reinforcement Learning",
      "Generative AI and LLMs",
      "Dimensionality Reduction",
    ],
  },
  {
    id: 5,
    img: "https://res.cloudinary.com/dagggqd6g/image/upload/v1765819336/Indian_Space_Research_Organisation_Logo.svg_y3bodx.png",
    role: "ISRO Robotics Challenge-URSC 2024 (IRoC-U2024)",
    company: "ISRO",
    date: "Nov 2023 - May 2026",
    desc: "Participated in the ISRO Robotics Challenge-URSC 2024 (IRoC-U2024), showcasing expertise in robotics, engineering, and problem-solving within a competitive space exploration context.",
    skills: [
      "Rover Design",
      "Power Electronics",
      "ROS",
      "Simulation",
      "Computer Vision",
      "Path Planning",
      "Chassis Design",
      "Electronics",
      "Object Detection",
    ],
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcR4KCDcGyNkYW5Zgs0xHLh4SO28QcC2Vc4wF9Bz4aJrdw&s",
    role: "President",
    company: "N.E.R.D.S. NIT Silchar",
    date: "Aug 2023 - May 2026",
    desc: "As General Secretary of N.E.R.D.S NIT Silchar, I lead initiatives promoting innovation, organize technical events, mentor members, and foster collaboration to enhance technical skills and knowledge.",
    skills: [
      "Arduino IDE",
      "Sensor Modules",
      "Programming",
      "Hardware",
      "IOT Modules",
    ],
  },
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSpn5WB-RTXBn5P8cSwUSpjREVlqHfAHUiq0Bya4A4&s",
    role: "Junior Technical Associate",
    company: "E-Cell NIT Silchar",
    date: "August 2023 - April 2024",
    desc: "Working on the frontend of the web application using ReactJS, HTML,Java=script, and CSS.",
    skills: [
      "ReactJS",
      "NextJS",
      "HTML",
      "CSS",
      "SASS",
      "JavaScript",
      "NodeJS",
      "MongoDB",
    ],
  },
  {
    id: 2,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTuRe7MZ4Gdpy1oqBvKI-gXer-0uOZJ8wkS2gFxSJqZMQ&s",
    role: "Development Wing Member",
    company: "Computer Science Society, NIT Silchar",
    date: "Sep 2023 - May 2024",
    desc: "Contributing to different open-source projects",
    skills: [
      "ReactJS",
      "HTML",
      "CSS",
      "JavaScript",
      "NodeJS",
      "ExpressJS",
      "MongoDB",
    ],
  },
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQgZjfVFbm53NoqtHcNsIqgDzSzyqdphtlSLQSIL0IWog&s",
    role: "Web Development Intern",
    company: "Bharat Intern",
    date: "Jun 2023 - July 2023",
    desc: "Had Experience of building responsive web layouts and designs for website including building and deployment.",
    skills: [
      "HTML",
      "CSS",
      "JavaScript",
    ],
  },

];

export const education = [
  {
    id: 0,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTa2ngdVpqch_pC2GJFdx3xlDt6_PtNBLwXYW6Ut_S_Ug&s",
    school: "National Institute of Technology, Silchar",
    date: "Nov 2022 - May 2026",
    grade: "9.38 CGPA",
    desc: "Completed my Bachelor's degree in Computer Science and Engineering from NIT Silchar with a CGPA of 9.38. Gained strong foundations in Data Structures, Algorithms, Discrete Mathematics, and Object-Oriented Programming, along with hands-on experience through academic and project work.",
  },
  {
    id: 1,
    img: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQuuhMqDyjarA71KSbNI2P0vezVXjKwLDDRxnAKjfMd1g&s",
    school: "Ramanuj Gupta Senior Secondary School",
    date: "Apr 2019 - Jun 2021",
    grade: "92.6%",
    desc: "I completed my class 12 high school education at Ramanuj Gupta Junior College, Dankuni, where I studied Science.",
  },
  {
    id: 2,
    img: "https://upload.wikimedia.org/wikipedia/commons/0/05/St._John_Vianney_Theological_Seminary_Seal.png",
    school: "St. Vianney School",
    date: "Jan 2007 - Jun 2018",
    grade: "90.4%",
    desc: "Attended St. Vianney School, receiving a comprehensive education that laid the foundation for academic excellence and personal growth, shaping a well-rounded individual.",
  },
];

export const projects = [



  {
    id: 9,
    title: "Space Rover",
    date: "May 2024",
    description:
      "Designed and implemented a robust software and electronics system for an autonomous space rover, achieving precise navigation and task execution in challenging environment",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765630706/Gemini_Generated_Image_82vi9c82vi9c82vi_ewep16.png",
    tags: [
      "Power Electronics",
      "Arduino",
      "Autonomous Navigation",
      "Jetson Nano",
    ],
    category: "robotics",
    github: "",
    webapp: "https://www.youtube.com/watch?si=3AEBZuTgmTvywpda&v=0hkg6x7ZlYw&feature=youtu.be",
  },
  {
    id: 2,
    title: "Spider-Bot",
    date: "Sep 2023",
    description:
      "Introducing our cutting-edge Spider Robot, powered by Arduino technology! This remarkable creation combines robotics and innovation, showcasing intricate movements and impressive functionality. With a sleek design and advanced capabilities, our Spider Robot is ready to amaze and inspire. Explore the future of robotics with us!",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765630438/Gemini_Generated_Image_s1msmgs1msmgs1ms_mp4bgl.png",
    tags: [
      "Arduino",
      "Hardware",
      "Bluetooth Module",
      "Sensors",
    ],
    category: "robotics",
    github: "https://github.com/swarupecenits/Spidy-The-Spider-Robot.git",
    webapp: "https://youtu.be/MOtOSJDkom8?si=WjYqGAIusp_0Lcip",
  },
  {
    id: 2,
    title: "Bionic Robotic Hand",
    date: "Nov 2025",
    description:
      "A Bio-inspired robotic hand featuring tendon-driven motion, precise finger control, and lightweight design for realistic grasping, assistive applications, and advanced prosthetic research.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765630282/unnamed_udfg2a.jpg",
    tags: [
      "Arduino",
      "OpenCV",
      "Mediapipe",
      "Python",
    ],
    category: "robotics",
    github: "https://github.com/swarupecenits/Bionic-Hand.git",
    webapp: "",
  },
  {
    id: 2,
    title: "17-DOF Humanoid Robot",
    date: "Sep 2025",
    description:
      "A 17-DOF humanoid robot capable of dynamic movement, precise joint control, and human-like motion for advanced research, manipulation, and robotics experimentation.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765630692/Gemini_Generated_Image_gjmje4gjmje4gjmj_sm4biq.png",
    tags: [
      "Arduino",
      "PID Tuning",
      "Hardware",
      "Python",
    ],
    category: "robotics",
    github: "",
    webapp: "",
  },
  {
    id: 2,
    title: "Quadcopter Drone",
    date: "Oct 2020",
    description:
      "Introducing our high-performance autonomous Quadcopter Drone, powered by the Pixhawk 6X Flight Controller and Jetson Orin Nano! This advanced UAV is designed for precise control, stability, and seamless autonomous flight. Equipped with cutting-edge sensors and a powerful flight system, it delivers exceptional aerial maneuverability. Experience next-gen drone technology with our Quadcopter Drone!",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765630946/Gemini_Generated_Image_9h1ofu9h1ofu9h1o_d2cfyd.png",
    tags: [
      "Drone",
      "Mission Planner",
      "Flight Controller",
      "Pixhawk 6X",
    ],
    category: "robotics",
    github: "",
    webapp: "",
  },
  {
    id: 1,
    title: "Incandescence-2024 Website",
    date: "Feb 2024",
    description:
      "Collaborated in creating a vibrant event website for Incandescence, showcasing our college's spirit through interactive design, engaging content, and seamless functionality.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/WhatsApp_Image_2024-03-15_at_12.14.58_5441dd4c_z2hykr",
    tags: [
      "NextJS",
      "SASS",
      "FramerMotion",
      "NodeJS",
      "MongoDB",
    ],
    category: "web app",
    github: "https://github.com/Ecell-NITS/Incand24-frontend.git",
    webapp: "https://www.incand.co.in/",
  },
  {
    id: 92,
    title: "MovieZone App",
    date: "Mar 2025",
    description:
      "A React Native movie browsing app built with Expo and Appwrite, providing users with a seamless experience to browse, search, and watch their favorite movies. Features include authentication, movie recommendations, and smooth UI for an engaging viewing experience.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765631416/Gemini_Generated_Image_skszjuskszjusksz_rwbcy7.png",
    tags: [
      "ReactNative",
      "Expo",
      "Appwrite",
    ],
    category: "Mobile app",
    github: "https://github.com/swarupecenits/Movie-App.git",
    webapp: "https://docs.google.com/uc?export=download&id=1CsScMQbyhw7P-J_R45ApXNENTCdnJsMy",
  },
  {
    id: 92,
    title: "Habix App",
    date: "Apr 2026",
    description:
      "A React Native habit tracking app built with Expo, designed to provide a calm and engaging experience for building consistency. Habix transforms daily habits into a growing digital garden, where each completed habit nurtures a plant that evolves over time. The app features a modern dark aesthetic UI, smooth animations, habit insights, and seamless tracking to make self-improvement feel rewarding and visually satisfying.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/v1775411207/Gemini_Generated_Image_tx84bwtx84bwtx84_g40pry.png",
    tags: [
      "ReactNative",
      "Expo",
      "Supabase",
      "Nativewind",
    ],
    category: "Mobile app",
    github: "https://github.com/swarupecenits/Habix.git",
    webapp: "https://docs.google.com/uc?export=download&id=1m9nUlIrsSuW0k8jvdfd4hEqoDNHkOWjY",
  },
  {
    id: 93,
    title: "Zesty App",
    date: "Dec 2025",
    description:
      "A React Native food delivery app built with Expo and Appwrite, featuring seamless ordering, real-time tracking, and personalized dining recommendations.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/v1765962789/WhatsApp_Image_2025-12-17_at_14.42.50_cef1b10f_h6uec0.jpg",
    tags: [
      "ReactNative",
      "Expo",
      "Appwrite",
    ],
    category: "Mobile app",
    github: "https://github.com/swarupecenits/Zest-India.git",
    webapp: "",
  },
  {
    id: 7,
    title: "Tecnoesis-2024 Website",
    date: "Jan 2024",
    description:
      "Collaborated on vibrant Tecnoesis event website, ensuring interactive design, engaging content, and seamless functionality in Technical Fest, showcasing teamwork and college spirit.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/rxnglcnzxvz29tmtrhtm",
    tags: [
      "ReactJS",
      "ModuleCSS",
      "Animation",
      "NodeJS",
      "Firebase",
    ],
    category: "web app",
    github: "https://github.com/gdsc-nits-org/tecnoesis-web.git",
    webapp: "https://www.tecnoesis.co.in/",
  },
  {
    id: 7,
    title: "Rainwise Website",
    date: "Oct 2025",
    description:
      "RainWise provides smart rainwater harvesting, storage, and analysis solutions for sustainable water management using IoT technology and data insights.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765636571/Gemini_Generated_Image_m1k02m1k02m1k02m_zxc7sq.png",
    tags: [
      "ReactJS",
      "Tailwind",
      "Machine Learning",
      "Ai Agent",
      "OpenCV",
      "NodeJS",
    ],
    category: "web app",
    github: "https://github.com/pragyan4261/Rainwater-Harvest-PRO.git",
    webapp: "https://rain-wise.netlify.app/",
  },
  {
    id: 7,
    title: "Genimeds AI Healthcare App",
    date: "June 2025",
    description:
      "Empowering users with affordable healthcare through AI-driven prescription analysis, medicine insights, and proactive wellness support. This web app leverages advanced AI technologies to provide personalized healthcare solutions, making medical information accessible and actionable for everyone.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765636564/Gemini_Generated_Image_4qvdfk4qvdfk4qvd_qv5inv.png",
    tags: [
      "ReactJS",
      "AI Agent",
      "Azure AI Foundry",
      "OCR",
      "NodeJS",
      "Firebase",
    ],
    category: "web app",
    github: "https://github.com/swarupecenits/GeniMeds-AI-Powered-.git",
    webapp: "https://geni-meds-ai-powered.vercel.app/",
  },
  {
    id: 22,
    title: "Lip Reading Model",
    date: "May 2024",
    description:
      "LipSense is a deep learning model that performs automatic lip reading from video sequences. It combines 3D Convolutional Neural Networks (CNNs) to extract spatiotemporal features from the mouth region with Bidirectional LSTMs for sequence modeling, ultimately predicting spoken text using Connectionist Temporal Classification (CTC) loss for alignment.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/v1766257105/WhatsApp_Image_2025-12-21_at_12.24.05_AM_dlpbg8.jpg",
    tags: [
      "TensorFlow",
      "Keras",
      "Neural Network",
      "LipNet",
    ],
    category: "machine_learning",
    github: "https://github.com/swarupecenits/Lip-Reading-Model.git",
    webapp: "",
  },
  {
    id: 22,
    title: "Image Classification Model",
    date: "May 2024",
    description:
      "This Streamlit app is an Image Classifier that uses a pre-trained neural network model to classify uploaded images into various categories. The app provides a user-friendly interface for users to upload an image, and the model predicts the class of the image along with the corresponding accuracy.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/fftu4ohfilwnarilwkny",
    tags: [
      "TensorFlow",
      "Keras",
      "Numpy",
      "Pandas",
    ],
    category: "machine_learning",
    github: "https://github.com/swarupecenits/Image_Classifier_Model.git",
    webapp: "https://imageclassifiermodel-bywze.streamlit.app/",
  },
  {
    id: 23,
    title: "Facial Attendance System",
    date: "July 2024",
    description:
      "Developed a Face Recognition Based Attendance System, automating attendance tracking using Python, OpenCV, and Excel integration, ensuring efficient and accurate record-keeping.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765631611/Gemini_Generated_Image_1wqx3l1wqx3l1wqx_nbzcij.png",
    tags: [
      "OpenCV",
      "Streamlit",
      "Numpy",
      "Face-Recognition",
      "Python",
    ],
    category: "machine_learning",
    github: "https://github.com/swarupecenits/Facial-Attendance.git",
    webapp: "https://github.com/swarupecenits/Facial-Attendance.git",
  },
  {
    id: 7,
    title: "Design of a Robot Rover with 5 DOF Manipulator for Uneven Terrain",
    date: "Oct  2024",
    description:
      "Lunar autonomous rovers with manipulators may be considered as one of the most promising directions of lunar exploration with the help of space robotics, a lot of organizations and researchers are working on the production of high-tech rovers for planetary reconnaissance and sample collection missions. IROC-U 2024 is an event organized by ISRO to encourage the development of new-generation moon rovers. ",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765637013/Gemini_Generated_Image_w60gk0w60gk0w60g_oratf5.png",
    tags: [
      "Research",
      "Publications",
    ],
    category: "research",
    github: "",
    webapp: "https://www.researchgate.net/publication/385205778_Design_of_a_Robot_Rover_with_5_DOF_Manipulator_for_Uneven_Terrain",
  },
  {
    id: 7,
    title: "Oikyotaan-2024 Website",
    date: "April 2024",
    description:
      "Contributed to the Oikyotaan 2024 cultural event website by designing interactive elements, creating engaging content, ensuring seamless functionality, and enhancing the overall user experience. My goal was to showcase the vibrancy and spirit of our event and college.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/li4hmetwysdlhq9ziazn",
    tags: [
      "ReactJS",
      "SASS",
      "Animation",
    ],
    category: "web app",
    github: "https://github.com/gdsc-nits-org/oikyotaan-2024.git",
    webapp: "https://oikyotaan.in/",
  },
  {
    id: 7,

    title: "Krypto Blockchain App",
    date: "Jan 2025",
    description:
      "Developed a blockchain-based web application leveraging ReactJS, Solidity, and EtherJS to enable secure cryptocurrency transactions. Focused on creating an intuitive user interface, implementing smart contract functionality, and ensuring seamless integration with Ethereum wallets.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/erldlvnqednk28s103dx",
    tags: [
      "ReactJS",
      "Solidity",
      "EtherJS",
    ],
    category: "web app",
    github: "https://github.com/swarupecenits/Krypto.git",
    webapp: "https://krypto-pi.vercel.app/",
  },
  {
    id: 19,
    title: "N.E.R.D.S Robotics Club Website",
    date: "Oct 2024",
    description:
      "N.E.R.D.S Robotics Club website showcases innovative robotics projects, team achievements, and event highlights. A hub for tech enthusiasts, fostering collaboration, learning, and inspiring future engineers in robotics.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/v1765631700/Screenshot_2025-12-13_184447_nttbwe.png",
    tags: [
      "ReactJS",
      "Tailwind",
      "Framer Motion",
    ],
    category: "web app",
    github: "",
    webapp: "https://www.nerdsnitsilchar.in/",

  },
  {
    id: 12,
    title: "Chat Application",
    date: "Aug 2024",
    description:
      "C++ chat application utilizing socket programming for real-time messaging, supporting multiple clients with TCP/IP for reliable communication, providing a robust and efficient network-based communication solution.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765636610/Gemini_Generated_Image_r60znwr60znwr60z_g5or4y.png",
    tags: [
      "C++",
      "SOCKET",
      "Network Programming",
    ],
    category: "web app",
    github: "https://github.com/swarupecenits/Chat-Application.git",
    webapp: "https://github.com/swarupecenits/Chat-Application.git",
  },

  {
    id: 9,
    title: "AI Summarizer Website",
    date: "Jun 2024",
    description:
      "Discover the future of information processing with my AI web app powered by OpenAI's GPT-4. Effortlessly summarize web URLs for quick insights and enhanced productivity. Revolutionizing content consumption!",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/zssfpkyhciixlow4jj7z",
    tags: [
      "ReactJS",
      "API",
      "Redux",
      "TailwindCSS",
    ],
    category: "web app",
    github: "https://github.com/swarupecenits/ai-summarizer.git",
    webapp: "https://ai-summarizer-swarup.netlify.app/",
  },
  {
    id: 9,
    title: "Realtime Tracking App",
    date: "Oct 2024",
    description:
      "I developed a web application that tracks the real-time locations of multiple users and displays them on an interactive map. Each user can share their current location and view the locations of other connected users with live updates.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765636816/Gemini_Generated_Image_5hdlgs5hdlgs5hdl_btxh0m.png",
    tags: [
      "Express",
      "EJS",
      "Leaflet",
      "GeolocationAPI",
    ],
    category: "web app",
    github: "https://github.com/swarupecenits/Realtime-Tracking-App.git",
    webapp: "https://realtime-tracking-app-9uh8.onrender.com/",
  },
  {
    id: 9,
    title: "3D-Tshirt Designer",
    date: "Jul 2024",
    description:
      "I developed an interactive 3D Tshirt customization website where users can personalize colors, add logos, and generate AI designs. Utilizing React, Three.js, and OpenAI, I offer a unique and immersive user experience.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/b4ibfejpeopjlsnim0rj",
    tags: [
      "Three.js",
      "API",
      "OpenAI",
      "Framer Motion",
    ],
    category: "web app",
    github: "https://github.com/swarupecenits/3D-Tshirt_Desginer.git",
    webapp: "https://3-d-tshirt-desginer.vercel.app/",
  },
  {
    id: 9,
    title: "Face-HandGesture Control",
    date: "Aug 2024",
    description:
      "HandGesture Pro enables intuitive laptop control through hand commands. Using advanced gesture recognition, it allows users to perform actions and navigate interfaces with simple hand movements, enhancing productivity and user experience.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/uuorcqqsqep57shjliti",
    tags: [
      "CNN",
      "Mediapipe",
      "Open-CV",
      "Face-Mesh Detection",
    ],
    category: "machine_learning",
    github: "https://github.com/swarupecenits/Face-Mesh-Detection.git",
    webapp: "https://github.com/swarupecenits/Face-Mesh-Detection.git",
  },
  {
    id: 9,
    title: "Buisness Website",
    date: "Jun 2023",
    description:
      "To establish an online presence, communicate our services, and engage customers. Key features include a responsive design, services showcase, contact information, blog/news section, and social media integration.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/lryt7o1tpvmmw2ojpwan",
    tags: [
      "HTML",
      "CSS",
      "Javascript",
    ],
    category: "web app",
    github: "https://github.com/swarupecenits/Buisness.git  ",
    webapp: "https://swarupecenits.github.io/Buisness/",
  },
  {
    id: 1,
    title: "Y20-Event Website",
    date: "Aug 2023",
    description:
      "Develop the Y20 Event Website to showcase our event, promote registration, and provide attendees with essential information. The site will feature event details, a registration portal, speaker profiles, an agenda, and a contact page.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/xcvtgg44afcvlt25zqxr",
    tags: [
      "ReactJS",
      "CSS",
      "Javascript",
      "Bootstrap",
    ],
    category: "web app",
    github: "https://github.com/swarupecenits/y20-website-dev.git",
    webapp: "https://y20-website-dev.vercel.app/",
  },
  {
    id: 3,
    title: "Portfolio Website",
    date: "Jun 2023",
    description:
      "Elevate your online presence with a dynamic portfolio website project. Showcase your skills, creativity, and achievements through a visually stunning and user-friendly platform. Engage visitors with a captivating portfolio, personalized bio, and contact information, all while highlighting your unique talents and achievements. Let your digital footprint shine with your customized portfolio website.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/ydu2odkv0ijvoy62g5p3",
    tags: [
      "HTML",
      "CSS",
      "Javascript",
    ],
    category: "web app",
    github: "https://github.com/swarupecenits/Portfolio.git",
    webapp: "https://swarupecenits.github.io/Portfolio/",
  },
  {
    id: 2,
    title: "News-App",
    date: "Oct 2023",
    description:
      "Develop the Y20 Event Website to showcase our event, promote registration, and provide attendees with essential information. The site will feature event details, a registration portal, speaker profiles, an agenda, and a contact page.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/hu4x438zq3ci7i9qkqqs",
    tags: [
      "ReactJS",
      "CSS",
      "Javascript",
    ],
    category: "web app",
    github: "https://github.com/swarupecenits/News-app.git",
    webapp: "https://news-app-eta-orcin.vercel.app/",
  },



  {
    id: 2,
    title: "Bluetooth-Car",
    date: "Oct 2022",
    description:
      "Experience the future of mobility with our Bluetooth-controlled car. This advanced vehicle puts you in the driver's seat with a smartphone app, offering precision control and an exhilarating ride. Seamlessly navigate, accelerate, and steer as you explore the possibilities of connected driving. Unleash the power of Bluetooth technology today.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765638746/Gemini_Generated_Image_gerjtrgerjtrgerj_hkxpf9.png",
    tags: [
      "Arduino",
      "Hardware",
      "Bluetooth Module",
    ],
    category: "robotics",
    github: "https://github.com/swarupecenits/Bluetooth-Controlled-car.git",
    webapp: "https://youtu.be/KyjrGN9ZTPg?si=LOdZGxahC-Sqo95_",
  },
  {
    id: 2,
    title: "Self-Balancing Bot",
    date: "Oct 2024",
    description:
      "The Self Balancing Bot is a two-wheeled robot that uses a combination of sensors and control algorithms to maintain its balance autonomously. Powered by an MPU6050 gyroscope and accelerometer, along with PID control logic",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765638878/Gemini_Generated_Image_q9rq0jq9rq0jq9rq_yb1r5b.png",
    tags: [
      "Arduino Mega",
      "MPU6050",
      "PID Tuning",
    ],
    category: "robotics",
    github: "https://github.com/swarupecenits/Sef-Balanced-Bot.git",
    webapp: "",
  },
  {
    id: 2,
    title: "Blood Flow Monitoring System for Kidney Dialysis Machine",
    date: "May 2024",
    description:
      "Developed an innovative cloud-based blood flow monitoring system for dialysis machines during my internship, integrating real-time remote control, web-based functionality, and affordability to revolutionize healthcare accessibility and efficiency.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/qzmpswfg0lnexawxulym",
    tags: [
      "Arduino",
      "Machine Learning",
      "ESP32",
      "Web Services",
    ],
    category: "robotics",
    github: "https://github.com/swarupecenits/Dialysis-Machine.git",
    webapp: "",
  },
  

  {
    id: 2,
    title: "Maze-Solver-Bot",
    date: "Jan 2024",
    description:
      "Developed a maze-solving bot using Arduino Uno, L298N motor driver, and ultrasonic sensors, demonstrating technical skills in robotics and programming for autonomous navigation tasks.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/w_1000,ar_16:9,c_fill,g_auto,e_sharpen/v1765817919/huyf_dnxsh5.png",
    tags: [
      "Arduino",
      "Hardware",
      "Bluetooth Module",
      "Ultrasonic Sensors",
    ],
    category: "robotics",
    github: "https://github.com/swarupecenits/Maze_solver.git",
  },
  {
    id: 82,
    title: "NoteNest",
    date: "Jan 2025",
    description:
      "NoteNest is a powerful and intuitive desktop application designed for seamless note-taking and organization. With a clean interface and robust features, it allows users to create, categorize, and search notes effortlessly. Whether for personal use or professional productivity, NoteNest ensures your ideas are always within reach.",
    image:
      "https://res.cloudinary.com/dagggqd6g/image/upload/f_auto,q_auto/jq2zokyap9dvplqbhyhf",
    tags: [
      "C#",
      "Desktop App",
      "Windows",
      "",
    ],
    category: "Desktop App",
    github: "https://github.com/swarupecenits/NoteNestApp.git",
    webapp: "https://drive.google.com/file/d/1vOqY54U4xbd6byMZ49EO69x9I7sK9AqK/view?usp=sharing",
  },

];

export const TimeLineData = [
  { year: 2022, text: "Started my Development journey" },
  { year: 2023, text: "Shared my projects with the world" },
];
